import React from 'react';

import { ContactForm } from './ContactForm';

import '../../../css/components/contact/contact-page.scss';
export function ContactPage() {
  return (
    <div className="contact-page">
      <div className="headers">
        <div className="sub-header">
          Have a Question?
        </div>
        <div className="main-header">
          Give Us A Call
        </div>
        <div className="header-text">
          We're here to help you as much as we can. Let us know what you need!
        </div>
      </div>

      <div className="bottom-half">
        <div className="left-side">
          <div>
            Can't find what you are looking for? Here's a couple of common questions. But if you don't see your question, send us a message!
          </div>
        </div>
        <ContactForm />
      </div>
    </div>
  )
}